const big = require('./terminal/terminal')
const small = require('./terminal/terminal-small')

exports.render = function (qrData, options, cb) {
  if (options && options.small) {
    return small.render(qrData, options, cb)
  }
  return big.render(qrData, options, cb)
}
